import { useMeasure } from '@uidotdev/usehooks';
import React from 'react';
import { ResponsiveContainer } from 'recharts';

const SCALE_FACTOR = 1.08;

interface ResponsiveWrapperProps {
  children: React.ReactElement;
  minHeight?: number;
}

export function ResponsiveWrapper({ children, minHeight }: ResponsiveWrapperProps) {
  const [ref, { width }] = useMeasure();
  return (
    <div ref={ref} className="w-100">
      <ResponsiveContainer
        width={width! * SCALE_FACTOR}
        maxHeight={900}
        minHeight={minHeight || 350}
      >
        {children}
      </ResponsiveContainer>
    </div>
  );
}
